import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { PaymentsService } from '../payments.service';

@Injectable()
export class PaymentProcessingResolver implements Resolve<boolean> {
  constructor(private paymentsService: PaymentsService) {}

  public resolve(): Observable<boolean> {
    return this.paymentsService.isProcessingEnabled();
  }
}
